module.exports = __webpack_public_path__ + "img/scene18.5f916202.gif";